jQuery(function($) {
	var webStorage = function() {
		if (sessionStorage.getItem('access')) {
			// console.log('2回目以降のアクセス');
			$('html').addClass('is-finished');
			$('#js-loading').hide();
			setTimeout(function() {
				//coutup 開始
				countupTop();
			}, 400);
		} else {
			// console.log('初回アクセス');
			loadingwindow();
			sessionStorage.setItem('access', 0);
		}
	}
	webStorage();

	// loadingwindow();

	function loadingwindow() {
		$(window).on('load', function() {
			var count = 0;
			var innterval = setInterval(function() {
				if (count == 4) {
					clearInterval(innterval);
					// console.log('finish');
					if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
						scrolllock()
					}
					setTimeout(function() {
						$('html').addClass('is-finished');
						$('body').removeClass('navi_active');
						$('html').removeClass('is-navi-active');
						setTimeout(function() {
							$('html').removeClass('is-lock');
						}, 200);
						//coutup 開始
						countupTop();
					}, 100);

				} else {
					count++;
					count2 = count * 25;
					// console.log(count);
					$("#js-percent-text").text(count2);
					$('#js-progressbar').css({
						'width': count2 + '%'
					});
					$('html').addClass('is-lock');
					// $('body').addClass('navi_active');
					// $('html').addClass('is-navi-active');
					if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
						scrolllock()
					}
				}
			}, 400);
		});
	}


	//汽車 煙
	$.fn.parapara = function(o) {
		return this.each(function() {
			var o = $.extend({
				d: 1200
			}, o);
			var c = $(this).children();
			var a = 0;
			var r = function() {
				c.hide();
				c.eq(a % c.length).show();
				++a;
			}
			r();
			setInterval(r, o.d);
		});
	}
	$('.js-parapara').parapara();


	// coin ランダム表示
	// window.onload = function() {
	setInterval(function() {

		var E = $('.p-coin');
		var m = E.length;
		var n = parseInt(Math.random() * m);

		for (var i = m - 1; i >= 0; i--) {
			var e = E[i];
			$(e).removeClass('is-play');
		}
		$(E[n]).addClass('is-play');
	}, 4000);
	// }

});



function countupTop() {
	$('.js-countup01').numerator({
		easing: 'swing', // アニメーションの動き
		duration: 3000, // アニメーションの時間
		toValue: countup01, // どこまでカウントアップするか
		delimiter: ',', // ３桁ごとに区切る値
		rounding: 0 // 小数点以下の桁数
	});
	$('.js-countup02').numerator({
		easing: 'swing', // アニメーションの動き
		duration: 3000, // アニメーションの時間
		toValue: countup02, // どこまでカウントアップするか
		delimiter: ',', // ３桁ごとに区切る値
		rounding: 0 // 小数点以下の桁数
	});
	$('.js-countup03').numerator({
		easing: 'swing', // アニメーションの動き
		duration: 3000, // アニメーションの時間
		toValue: countup03, // どこまでカウントアップするか
		delimiter: ',', // ３桁ごとに区切る値
		rounding: 0 // 小数点以下の桁数
	});
}

function scrolllock() {
	if (!document.body.classList.contains('navi_active')) {
		// console.log('ok');
		document.body.classList.add('navi_active');

		var elem = document.getElementById('js-loading');
		elem.addEventListener('touchmove', function(e) {
			var scroll = elem.scrollTop;
			var range = elem.scrollHeight - elem.offsetHeight - 1;
			if (scroll < 1) {
				e.preventDefault();
				elem.scrollTop = 1;
			} else if (scroll > range) {
				e.preventDefault();
				elem.scrollTop = range;
			}
		});

	} else {
		// console.log('ok2');

		document.body.classList.remove('navi_active');
	}
}
//ブラウザ戻る進む対策（戻る進むでreload）
window.onpageshow = function(event) {
	if (event.persisted) {
		window.location.reload();
	}
}
